<template>
  <article>
    <h3 class="title">Alerts</h3>
    
    <div v-for="(notification, idx) of notifications" :key="idx" class="card">
      <header class="card-header">
        <p class="card-header-title">
          {{ notification.eventType }}
        </p>
      </header>

      <div class="card-content">
        <div class="content">
          <table class="table borderless">
            <tbody>
              <tr>
                <th>Time</th>
                <td>{{ formatTime(idx) }}</td>
              </tr>
              <tr>
                <th>Function</th>
                <td>
                  <router-link :to="{ name: 'HotpathDrilldown', query: { name: notification.fnName } }">
                    {{ notification.fnName }}
                  </router-link>
                </td>
              </tr>
              <tr>
                <th>Environment</th>
                <td>{{ notification.environment }}</td>
              </tr>
              <tr>
                <th>Commit</th>
                <td><code>{{ notification.commit.sha1 }}</code></td>
              </tr>
              <tr>
                <th># Calls</th>
                <td>{{ notification.nCalls }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import { gql } from "apollo-boost";

var moment = require("moment");

export default {
  name: "Notifications",
  props: {
    projectID: {
      type: Number,
      required: true
    }
  },
  apollo: {
    notifications: {
      query: gql`
        query notifications($query: NotificationQuery!) {
          notifications(query: $query) {
            id
            fnName
            environment
            commit {
              sha1
            }
            time
            nCalls
            eventType
          }
        }
      `,
      variables() {
        return {
          query: {
            projectID: this.projectID,
            environment: "production"
          }
        };
      }
    }
  },
  data() {
    return {
      notifications: []
    };
  },
  methods: {
    formatTime(idx) {
      return moment(this.notifications[idx].time).format("MM/DD/YYYY h:mm:ssa");
    }
  }
}
</script>

<style>
.hotpath-link {
  color: black;
}
</style>
